/**
 * Handmatig gekozen winkelwagen-aanbevelingen (snippets/cart-recommendations-manual.liquid).
 *
 * De kaarten staan al server-side in de HTML. Dit script doet maar een ding: producten
 * verbergen die inmiddels in de winkelwagen liggen. Dat is nodig omdat de drawer ook uit
 * een <template> gekloond wordt op het moment dat de eerste regel wordt toegevoegd - op
 * dat moment was de cart bij het renderen nog leeg, dus server-side filteren volstaat niet.
 */
const STORE_POLL_INTERVAL = 50;
const STORE_POLL_TIMEOUT = 10000;

function waitForCartStore() {
  return new Promise((resolve) => {
    if (window.theme?.cart?.store) {
      resolve(window.theme.cart.store);
      return;
    }

    const startedAt = Date.now();
    const timer = setInterval(() => {
      if (window.theme?.cart?.store) {
        clearInterval(timer);
        resolve(window.theme.cart.store);
      } else if (Date.now() - startedAt > STORE_POLL_TIMEOUT) {
        clearInterval(timer);
        resolve(null);
      }
    }, STORE_POLL_INTERVAL);
  });
}

class CartRecommendationsManual extends HTMLElement {
  async connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('product-card-mini[data-product-id]'));

    if (this.cards.length === 0) return;

    const store = await waitForCartStore();
    if (!store || !this.isConnected) return;

    this._sync(store.getState());
    this.unsubscribe = store.subscribe((state) => this._sync(state));
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  _sync(state) {
    const productIdsInCart = new Set(
      (state?.products?.items || []).map((item) => String(item.product_id)),
    );

    let visibleCount = 0;

    this.cards.forEach((card) => {
      const isInCart = productIdsInCart.has(card.getAttribute('data-product-id'));
      card.toggleAttribute('hidden', isInCart);
      if (!isInCart) visibleCount += 1;
    });

    this.toggleAttribute('hidden', visibleCount === 0);
  }
}

if (!customElements.get('cart-recommendations-manual')) {
  customElements.define('cart-recommendations-manual', CartRecommendationsManual);
}
